import { Row } from '@tanstack/react-table'
import moment from 'moment'

export function sortByDate<T extends Record<string, unknown>>(
  rowA: Row<T>,
  rowB: Row<T>,
  columnId: string
): number {
  const dateA = rowA.getValue(columnId)
    ? moment(rowA.getValue(columnId), 'MM/DD/YYYY HH:mm:ss z').valueOf()
    : 0
  const dateB = rowB.getValue(columnId)
    ? moment(rowB.getValue(columnId), 'MM/DD/YYYY HH:mm:ss z').valueOf()
    : 0
  if (dateA < dateB) return 1
  if (dateA > dateB) return -1
  return 0
}
